// extracted by mini-css-extract-plugin
module.exports = {"tagPrice":"styles_tagPrice__P1Az5","ownerFeesRate":"styles_ownerFeesRate__L6V_k","selected":"styles_selected__4obZr"};